/**
 * Year Selector Component
 * Allows user to select a year from 2015 to next year (for projections)
 */

import React from 'react';

interface YearSelectorProps {
  value: number;
  onChange: (year: number) => void;
  disabled?: boolean;
}

export const YearSelector: React.FC<YearSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];

  // Generate years from 2015 to next year (include next year for projection viewing)
  for (let year = currentYear + 1; year >= 2015; year--) {
    years.push(year);
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      disabled={disabled}
      className="px-2 py-1.5 text-sm bg-white border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    >
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};
